import React from "react";
import { useTranslation } from "react-i18next";
import redTagImage from "../../assets/images/Badgex0.5.png";

const ClosedBadge = ({ style }) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        position: "absolute",
        top: 8,
        left: 0,
        width: 88,
        height: 36,
        backgroundImage: `url(${redTagImage})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 5,
        pointerEvents: "none",
        ...style,
      }}
    >
      <span
        style={{
          color: "#fff",
          fontWeight: 700,
          fontSize: 12,
          textTransform: "uppercase",
          lineHeight: 1,
        }}
      >
        {t("Closed")}
      </span>
    </div>
  );
};

export default ClosedBadge;
